import React from 'react';
import PropTypes from 'prop-types';

const AfterTransactionWrapper = ({ children }) => {
  return (
    <div className="container-xl px-lg-0 h-100 d-flex flex-column justify-content-center mx-a">
      <div className="text-center">{children}</div>
    </div>
  );
};

AfterTransactionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AfterTransactionWrapper;
